import { BaseSerializer } from '/src/app/core/serializers/baseSerializer';

class BlacklistSerializer extends BaseSerializer {
  /**
   * Désérialise la réponse GET /bookmaker/blacklisted
   */
  deserializeList(raw) {
    const serverRes = raw.data || raw.error;
    const statusCode = serverRes?.statusCode;

    // 404 = aucun joueur blacklisté (liste vide, pas une erreur)
    if (statusCode === 404) {
      return { success: true, data: [] };
    }

    if (statusCode !== 200 && statusCode !== 201) {
      return {
        success: false,
        message:
          serverRes?.message ||
          `Erreur de récupération (Code: BLACKLIST_ERR_${statusCode || '500'})`,
        data: null
      };
    }

    const list = Array.isArray(serverRes?.data) ? serverRes.data : [];
    return {
      success: true,
      data: list.map((item) => ({
        id: item.id,
        playerId: item.playerId,
        service: item.service
      }))
    };
  }

  /**
   * Désérialise la réponse POST /bookmaker/blacklist/:id (ajout)
   */
  deserializeAdd(raw) {
    const serverRes = raw.data || raw.error;
    const statusCode = serverRes?.statusCode;

    if (statusCode === 200 || statusCode === 201) {
      return { success: true, message: serverRes?.message };
    }
    return {
      success: false,
      message: serverRes?.message || `Erreur d'ajout (Code: ${statusCode})`
    };
  }

  /**
   * Désérialise la réponse DELETE /bookmaker/blacklist/:id (suppression)
   */
  deserializeRemove(raw) {
    const serverRes = raw.data || raw.error;
    const statusCode = serverRes?.statusCode;

    if (statusCode === 200 || statusCode === 201) {
      return { success: true, message: serverRes?.message };
    }
    return {
      success: false,
      message: serverRes?.message || `Erreur de suppression (Code: ${statusCode})`
    };
  }
}

export const serializer = new BlacklistSerializer();
